jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  let haveNoStock = false;
  $(document).on("variant:changed", function (evt) {
    //console.log(evt.currentVariant)
    const quantity = evt.currentVariant.inventory_quantity <= 0 ? 0 : evt.currentVariant.inventory_quantity;
    if (evt.currentVariant && evt.currentVariant.inventory_management) {

      $(".t4s-stock_qty").html(
        `<span class="t4s-stock_qty_text"> 在庫数 <span class="t4s-stock_qty_qty">${quantity}</span></span>`
      );
    } else {
      $(".t4s-stock_qty").html("");
    }
    $('.t4s-pr__op').attr('data-stock', quantity);
    window.lightingOpText();
  });

  $(".tab-link").click(function () {
    var tabID = $(this).attr("data-tab");

    $(this).addClass("active").siblings().removeClass("active");
    console.log("#t4s-" + tabID);
    $("#t4s-" + tabID)
      .addClass("t4s-tab-active")
      .siblings()
      .removeClass("t4s-tab-active");
  });

  async function fetchAndExtractJson() {
    const url = "/cart?view=custom";
    try {
      const response = await fetch(url);
      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");
      const scriptTag = doc.querySelector("script#t4_custom");

      if (scriptTag) {
        const jsonData = JSON.parse(scriptTag.textContent);
        //console.log("Dữ liệu JSON:", jsonData);
        return jsonData; // Trả về dữ liệu JSON nếu cần
      } else {
        console.error('Không tìm thấy thẻ <script> với id="custom-data"');
        return null;
      }
    } catch (error) {
      console.error("Lỗi khi fetch dữ liệu:", error);
    }
  }
  function checkType(products) {
    const lightingPr = products.filter((pr) => pr.lighting);
    let op_products = [];
    let type;
    type = products.find((pr) => pr.super_first_have_stock);
    if (type)
      op_products.push({
        type: "super_first_have_stock",
        quantity: type.quantity,
        text_date: T4CustomVar.super_first_stock_date,
        text_time: T4CustomVar.super_first_stock_time,
      });
    type = products.find((pr) => pr.super_first_no_stock);
    if (type)
      op_products.push({
        type: "super_first_no_stock",
        quantity: type.quantity,
        text_date: T4CustomVar.super_first_nostock_date,
        text_time: T4CustomVar.super_first_nostock_time,
      });
    type = products.find((pr) => pr.first_have_stock);
    if (type)
      op_products.push({
        type: "first_have_stock",
        quantity: type.quantity,
        text_date: T4CustomVar.first_stock_date,
        text_time: T4CustomVar.first_stock_time,
      });
    type = products.find((pr) => pr.first_no_stock);
    if (type)
      op_products.push({
        type: "first_no_stock",
        quantity: type.quantity,
        text_date: T4CustomVar.first_nostock_date,
        text_time: T4CustomVar.first_nostock_date,
      });
    //const opProductQty = op_products.reduce((acc, curren) => acc + curren.quantity, 0);
    let inStockQty = 0,
      outStockQty = 0,
      lightingPrInStock = products.filter((pr) => pr.quantity <= pr.stock && pr.lighting),
      lightingPrNoStock = products.filter((pr) => pr.quantity > pr.stock && pr.lighting),
      // lightingInstockTotal  = lightingPrInStock.reduce((acc, curren) => acc + curren.quantity, 0),
      // lightingNostockTotal  = lightingPrNoStock.reduce((acc, curren) => acc + curren.quantity, 0);
      lightingInstockTotal = lightingPrInStock.reduce((acc, curren) => acc + curren.quantity, 0),
      lightingNostockTotal = lightingPrNoStock.reduce((acc, curren) => acc + curren.quantity, 0);
    op_products.forEach((op) => {
      if (op.type === "super_first_no_stock" || op.type === "first_no_stock") {
        outStockQty += op.quantity;
      } else {
        inStockQty += op.quantity;
      }
    });
    // console.log("Instock", inStockQty, lightingInstockTotal);
    // console.log("Outstock", outStockQty, lightingNostockTotal);
    if (lightingPrInStock.length > inStockQty || lightingPrNoStock.length > outStockQty) {
      //lightingPr.length > op_products.length
      const OpNoStock = op_products.filter((op) => op.type === "super_first_no_stock" || op.type === "first_no_stock"),
        OpNoStockTotal = OpNoStock.reduce((acc, curren) => acc + curren.quantity, 0);
      const checkFirstNo = op_products.find((op) => op.type === "first_no_stock");
      if (OpNoStockTotal > 0) {
        if (lightingPrNoStock.length > OpNoStockTotal) {
          op_products.push({
            type: "normal_no_stock",
            quantity: null,
            text_date: T4CustomVar.normal_nostock_date,
            text_time: T4CustomVar.normal_nostock_date,
          });
        } else {
          if(!checkFirstNo)
            op_products.push({
              type: "normal_have_stock",
              quantity: null,
              text_date: T4CustomVar.normal_stock_date,
              text_time: T4CustomVar.normal_stock_time,
            });
        }
      } else {
        if (lightingNostockTotal > 0) {
          op_products.push({
            type: "normal_no_stock",
            quantity: null,
            text_date: T4CustomVar.normal_nostock_date,
            text_time: T4CustomVar.normal_nostock_date,
          });
        } else {
          if(!checkFirstNo)
            op_products.push({
              type: "normal_have_stock",
              quantity: null,
              text_date: T4CustomVar.normal_stock_date,
              text_time: T4CustomVar.normal_stock_time,
            });
        }
      }

      /*
      lightingPr.forEach((pr) => {
        const type = pr.quantity > pr.stock ? "normal_no_stock" : "normal_have_stock";
        const check = op_products.find((op) => op.type === type);
        if (!check) {
          op_products.push({
            type: type,
            quantity: pr.quantity,
            text: "Delivery date of normal",
          });
        }
      });
      */
    }

    return op_products;
  }
  function textDate(op, inStock = true) {
    switch (op) {
      case "first_have_stock":
        return T4CustomVar.first_stock_date;
      case "first_no_stock":
        return T4CustomVar.first_nostock_date;
      case "super_first_have_stock":
        return T4CustomVar.super_first_stock_date;
      case "super_first_no_stock":
        return T4CustomVar.super_first_nostock_date;
      case "normal_no_stock":
        return T4CustomVar.normal_nostock_date;
      default:
        return T4CustomVar.normal_stock_date;
    }
  }
  function textTime(op, inStock = true) {
    switch (op) {
      case "first_have_stock":
        return T4CustomVar.first_stock_time;
      case "first_no_stock":
        return T4CustomVar.first_nostock_time;
      case "super_first_have_stock":
        return T4CustomVar.super_first_stock_time;
      case "super_first_no_stock":
        return T4CustomVar.super_first_nostock_time;
      case "normal_no_stock":
        return T4CustomVar.normal_nostock_time;
      default:
        return T4CustomVar.normal_stock_time;
    }
  }
  function textContent(op, inStock = true) {
    switch (op) {
      case "first_have_stock":
        return T4CustomVar.first_stock_content;
      case "first_no_stock":
        return T4CustomVar.first_nostock_content;
      case "super_first_have_stock":
        return T4CustomVar.super_first_stock_content;
      case "super_first_no_stock":
        return T4CustomVar.super_first_nostock_content;
      case "normal_no_stock":
        return T4CustomVar.normal_nostock_content;
      default:
        return T4CustomVar.normal_stock_content;
    }
  }
  function calculateVariantQty(products) {
    // Tính tổng quantity theo variant_id
    const stockByVariantId = products.reduce((acc, item) => {
      const key = item.variant_id;
      if (!acc[key]) {
        acc[key] = 0;
      }
      acc[key] += item.quantity;
      return acc;
    }, {});

    // Cập nhật lại quantity cho mỗi item
    return products.map(item => ({
      ...item,
      quantity: stockByVariantId[item.variant_id]
    }));
  }
  async function handleOpShipping(update = false) {
    const cart = await fetchAndExtractJson();
    const checkOutWrapper = document.querySelector(".t4s-btn-group__checkout-update");
    //console.log(cart);
    if (!cart || !cart.product || !checkOutWrapper) return;
    const products = calculateVariantQty(cart.product);
    const check = products.some((pr) => pr.lighting);
    if (!check) return;
    const type = checkType(products),
      product = getProducts(products);

    if (!type.length) return;
    const lightingPrNoStock = products.filter((pr) => pr.quantity > pr.stock && pr.lighting)
    haveNoStock = lightingPrNoStock.length > 0;

    const inStock = product && parseInt(product.stock) > 0 ? true : false;
    const dateSelect = [];

    type.forEach((t, index) => {
      dateSelect.push({
        date: getDate(t, inStock, index),
        type: t.type,
        text_date: t.text_date,
        text_time: t.text_time,
      });
    });

    let html, dateSelectHtml;
    dateSelectHtml = dateSelect
      .map(
        (dt, index) => `
          <div class="delivery_box" data-text-date="${dt.text_date}" data-text-time="${dt.text_time}">
              <p class="delivery-title" style="font-size: 14px">${textDate(dt.type, inStock) || `ご希望納品日`}</p>
              <div>
                <div class="delivery-select-container amp-select-allow">
                  ${dt.date}
                </div>
              </div>
              ${
                isShowTime(dt.type)
                  ? `
                  <p class="delivery-title" style="font-size: 14px">${textTime(dt.type) || `ご希望時間帯`}</p>
                  <div>
                    <div class="delivery-select-container amp-select-allow">
                      <select
                        name="op_time_${index}"
                      >
                        <option value="指定なし">指定なし</option>
                        <option value="午前中">午前中</option>
                        <option value="14時～16時">14時～16時</option>
                        <option value="16時～18時">16時～18時</option>
                        <option value="18時～20時">18時～20時</option>
                        <option value="19時～21時">19時～21時</option>
                      </select>
                    </div>
                  </div>
                `
                  : ``
              }

              ${
                textContent(dt.type, inStock)
                  ? `<div class="delivery-item-content">${textContent(dt.type, inStock)}</div>`
                  : ``
              }

            </div>
      `
      )
      .join("");
    html = `
      <div
        id="cart-delivery-datetime"
      >
        <div>
          <div>
            <div id="delivery-datetime--isRender" data-testid="delivery-datetime--isRender" class="delivery-container">
            ${dateSelectHtml}
            ${T4CustomVar.delevery_checkbox_text?
              `<p class="t4s-pr t4s-cart__delivery_agree" ${lightingPrNoStock.length !== 0 ? `style="display:none;"` : ``}>
                  <input type="checkbox" id="t4s-cart__delivery_agree" data-text="${T4CustomVar.delevery_checkbox_text}"/>
                  <label for="t4s-cart__delivery_agree">${T4CustomVar.delevery_checkbox_text}</label>
                </p>
                `
              : ``
            }
            <div style="font-size: 12px">
              <div class="delivery-caution__statement" style="font-size: 12px">
                <div>${
                  cart.op_text || "※配送業者によって、正しく配置されない可能性がございます。ご理解の上ご指定下さい"
                }</div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    `;
    let shipping;
    if (update) {
      shipping = document.querySelector(".shipping-op-wrapper");
      shipping.innerHTML = html;
    } else {
      shipping = document.createElement("div");
      shipping.classList.add("shipping-op-wrapper");
      shipping.innerHTML = html;
      checkOutWrapper.prepend(shipping);
    }
    handleSelectChange();
    //handleCheckoutBtn();
  }
  function handleSelectChange() {
    $('select[name="op_date"], select[name="op_time"]').on("change", function () {
      if ($(this).val() !== "") {
        $(this).css("border-color", "var(--border-color)");
      }
    });
  }
  function handleCheckoutBtn() {
    const dataCheckbox = "[data-agree-checkbox]";
    $('button[name="checkout"]').on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $form = $(this).closest("form"),
        $checkbox = $form.find(`[type="checkbox"]${dataCheckbox}`);

      if (!$form[0] || $checkbox.length == 0) return;
      const shipping = $form.find(".shipping-op-wrapper");
      if (shipping) {
        const opDate = shipping.find('select[name="op_date"]'),
          opTime = shipping.find('select[name="op_time"]');
        if (opDate.length && opDate.val() === "") {
          opDate.css("border-color", "red");
          return;
        }
        if (opTime.length && opTime.val() === "") {
          opTime.css("border-color", "red");
          return;
        }

        const note = $form.find('[name="note"]');
        if (note.length) {
          let inputString = note.val() || "";
          // Kiểm tra và thay thế "Shipping date"
          if (inputString.match(/Shipping date:/)) {
            inputString = inputString.replace(/(Shipping date:\s*)(\d{4}-\d{2}-\d{2}\s*\(.+\))/, `$1${opDate.val()}`);
          } else {
            inputString += `\n-Shipping date: ${opDate.val()}`;
          }

          if (inputString.match(/Shipping time:/)) {
            inputString = inputString.replace(/(Shipping time:\s*)(\d+時～\d+時)/g, `$1${opTime.val()}`);
          } else {
            inputString += `\n-Shipping time: ${opTime.val()}`;
          }

          note.val(inputString);
        }
      }

      if ($checkbox.is(":checked")) {
        $form.submit();
      } else {
        T4SThemeSP.Notices(T4Sstrings.agree_checkout);
      }
    });
  }
  function isShowTime(op) {
    switch (op) {
      case "super_first_have_stock":
        return T4CustomVar.op_day_super_have_stock.trim() !== "";
      case "super_first_no_stock":
        return T4CustomVar.op_day_super_no_stock.trim() !== "";
      case "first_have_stock":
        return T4CustomVar.op_day_first_have_stock.trim() !== "";
      case "first_no_stock":
        return T4CustomVar.op_day_first_no_stock.trim() !== "";
      case "normal_no_stock":
        return T4CustomVar.op_day_normal_no_stock.trim() !== "";
      default:
        return T4CustomVar.op_day_normal_have_stock.trim() !== "";
    }
  }
  function getDate(op, hasStock, index = 0) {
    const type = op.type;
    if (type === "super_first_have_stock") {
      if (T4CustomVar.op_day_super_have_stock) {
        const range = T4CustomVar.op_day_super_have_stock.split("-");
        return renderDropdown(range[0], range[1], range[1], index);
      } else {
        return renderDropdown(0, 0, 0, index, true);
      }
    } else if (type === "super_first_no_stock") {
      if (T4CustomVar.op_day_super_no_stock) {
        const range = T4CustomVar.op_day_super_no_stock.split("-");
        return renderDropdown(range[0], range[1], range[1], index, false, false, true);
      } else {
        return renderDropdown(0, 0, 0, index, true);
      }
      //return renderDropdown(10, 15, 15, true);
    } else if (type === "first_have_stock") {
      if (T4CustomVar.op_day_first_have_stock) {
        const range = T4CustomVar.op_day_first_have_stock.split("-");
        return renderDropdown(range[0], range[1], range[1], index);
      } else {
        return renderDropdown(0, 0, 0, index, true);
      }
      //return renderDropdown(10, 15, 15);
    } else if (type === "first_no_stock") {
      if (T4CustomVar.op_day_first_no_stock) {
        const range = T4CustomVar.op_day_first_no_stock.split("-");
        return renderDropdown(range[0], range[1], range[1], index, false, false, true);
      } else {
        return renderDropdown(0, 0, 0, index, true);
      }
      //return renderDropdown(36, 61, 61);
    } else if (type === "normal_no_stock") {
      if (T4CustomVar.op_day_normal_no_stock) {
        const range = T4CustomVar.op_day_normal_no_stock.split("-");
        return renderDropdown(range[0], range[1], range[1], index);
      } else {
        return renderDropdown(0, 0, 0, index, true);
      }
      //return renderDropdown(71, 91, 91);
    } else if (type === "normal_have_stock") {
      if (T4CustomVar.op_day_normal_have_stock) {
        const range = T4CustomVar.op_day_normal_have_stock.split("-");
        return renderDropdown(range[0], range[1], range[1], index);
      } else {
        return renderDropdown(0, 0, 0, index, true);
      }
      //return renderDropdown(16, 31, 31);
    }
  }

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dayName = date.toLocaleDateString("ja-JP-u-ca-japanese", { weekday: "short" });
    return `${year}/${month}/${day} (${dayName})`;
  }

  // Function to check if the day is a weekend (Saturday or Sunday)
  function isWeekend(date) {
    const day = date.getDay();
    return day === 0; //|| day === 6; // 0 is Sunday, 6 is Saturday
  }

  // Function to check if the date is a holiday in Japan
  function isHoliday(date, holidays) {
    const formattedDate = date.toISOString().split("T")[0];
    return holidays.includes(formattedDate);
  }
  function getDatesBetween(startDate, endDate) {
    const dates = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  }
  function calculateStartDate(daysToAdd, holidays) {
    let date = new Date(); // Lấy ngày hôm nay
    date.setDate(date.getDate() + 1); // Bắt đầu từ ngày mai
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      // Nếu ngày hiện tại không phải là Chủ Nhật, tăng số ngày hợp lệ
      if (date.getDay() !== 0 && !isHoliday(date, holidays)) {
        addedDays++;
      }
      // Chỉ chuyển sang ngày tiếp theo nếu chưa đạt đủ 16 ngày hợp lệ
      if (addedDays < daysToAdd) {
        date.setDate(date.getDate() + 1);
      }
    }

    return date.setDate(date.getDate() + 1);
  }

  function generateValidDates(holidays, startOffset, endOfset) {
    const startDate = calculateStartDate(startOffset, holidays);
    const endDate = calculateStartDate(endOfset, holidays);
    return getDatesBetween(startDate, endDate);
  }

  // Function to render the dropdown options
  function renderDropdown(start, end, opDays, index, noOption = false, productPage = false, pleaseAsk = false) {
    const customHoliday = T4CustomVar && T4CustomVar.shop_holidays ? T4CustomVar.shop_holidays.split(";") : [];

    const holidays = [
      // Holidays for 2024
      "2024-01-01", // New Year's Day
      "2024-02-11", // National Foundation Day
      "2024-04-29", // Showa Day
      "2024-05-03", // Constitution Memorial Day
      "2024-05-04", // Greenery Day
      "2024-05-05", // Children's Day
      "2024-10-14", // Children's Day
      "2024-11-04", // Children's Day
      "2024-11-23", // Children's Day
      "2024-12-30", // Children's Day
      "2024-12-31", // Children's Day
      // Holidays for 2025
      "2025-01-01", // New Year's Day
      "2025-01-08", // New Year's Day
      "2025-01-13", // Coming of Age Day
      "2025-02-11", // National Foundation Day
      "2025-02-23", // Emperor's Birthday
      "2025-03-20", // Vernal Equinox Day
      "2025-04-29", // Showa Day
      "2025-05-03", // Constitution Memorial Day
      "2025-05-04", // Greenery Day
      "2025-05-05", // Children's Day
      "2025-07-21", // Marine Day
      "2025-08-11", // Mountain Day
      "2025-09-15", // Respect for the Aged Day
      "2025-09-23", // Autumnal Equinox Day
      "2025-10-13", // Health and Sports Day
      "2025-11-03", // Culture Day
      "2025-11-23", // Labor Thanksgiving Day
      ...customHoliday,
    ];

    //const holidays = await fetchHolidays(2024); // Fetch holidays for the year 2024
    const validDates = generateValidDates(holidays, start - 1, end - 1);
    if (productPage) {
      return validDates;
    }
    let html;
    if (noOption) {
      html = `<p>${T4CustomVar.text_no_op}</p>`;
    } else {
      html = pleaseAsk ? `<select name="op_date_${index}"><option value="納期ご相談の上ご購入下さい">納期ご相談の上ご購入下さい</option>` : `<select name="op_date_${index}">${haveNoStock === true ? `<option value="指定なし(最長${opDays}営業日)">指定なし(最長${opDays}営業日)</option>` : ``}`;
      validDates.forEach((date) => {
        html += `<option value="${formatDate(date)}">${formatDate(date)}</option>`;
      });
      html += "</select>";
    }

    return html;
  }
  function getProducts(products) {
    const prods = products.filter((pr) => pr.lighting);
    if (prods.length === 1) return prods[0];
    const pr = prods.reduce((prev, curr) => (prev.quantity > curr.quantity ? prev : curr));
    return pr;
  }

  function lightingOpText() {
    const op = $(".t4s-pr__op");
    if (op.length) {
      let text = '',
        qty = op.attr("data-stock");
      let validDates = [];
      if (parseInt(qty) > 0) {
        text = op.data("text");
        if (T4CustomVar.op_day_normal_have_stock) {
          const range = T4CustomVar.op_day_normal_have_stock.split("-");
          validDates = renderDropdown(range[0], range[1], range[1], 0, false, true);
        }
      } else {
        text = op.data("text-outstock");
        if (T4CustomVar.op_day_normal_no_stock) {
          const range = T4CustomVar.op_day_normal_no_stock.split("-");
          validDates = renderDropdown(range[0], range[1], range[1], 0, false, true);
        }
      }
      if (!validDates.length) return;
      text = text.replace(/\{\s*date\s*\}/g, `${formatDate(validDates[0])} - ${formatDate(validDates.pop())}`);
      op.html(text);
    }
  }
  if ($("body").hasClass("template-cart")) {
    handleOpShipping();
    const note = $("body").find('[name="note"]');
    console.log('note: ', note.val());

    if (note.length) {
      note.val("");
      note.css("display", "block");
    }

    $(document).on("change", 'select[name="op_date_0"]', function () {
      if ($(this).val().includes("指定なし")) {
        $('.t4s-cart__delivery_agree').css("display", "none");
      } else {
        $('.t4s-cart__delivery_agree').css("display", "block");
      }
    });
  }
  if ($("body").hasClass("template-product")) {
    lightingOpText();
    window.lightingOpText = lightingOpText;
  }

  window.handleOpShipping = handleOpShipping;
});
